export default "__VITE_ASSET__BCIr_te8__"